import { useFlag as useUnleashFlag } from '@unleash/proxy-client-react';
import { useEffect, useState } from 'react';

// window.features is passed to the frontend in the blade file
// path: resources/views/public/landing_pages_v2/tivly_landing_page/shared_vars.blade.php

// Local feature flags are the config file in
// path: config/features.php

/**
 * Custom hook to check if a feature flag is enabled
 * @param {string} featureName - The name of the feature flag to check
 * @returns {boolean} - Whether the feature is enabled or not
 */
const useFlag = featureName => {
    const enabled = useUnleashFlag(featureName);
    const [isEnabled, setIsEnabled] = useState(enabled);
    useEffect(() => {
        setIsEnabled(enabled);
    }, [enabled]);

    return isEnabled;
};

/**
 * Gets the configuration object for the Unleash client
 * @param {string} appName - The name of the application to identify it in Unleash
 * @returns {Object|undefined} Configuration object containing Unleash client settings or undefined if config is missing
 */

const getConfig = appName => {
    let config;
    if (!window?.unleash_config) return config;

    const apiKey = window?.unleash_config?.api_key || 'bm9uZQ=='; // Base64 encoding of 'none': btoa('none') === 'bm9uZQ==' as some value is required
    const appUrl = window?.unleash_config?.app_url ? `${window.unleash_config.app_url}frontend/` : '';

    if (window.unleash_config && appUrl) {
        config = {
            url: appUrl, // Your front-end API URL or the Unleash proxy's URL (https://<proxy-url>/proxy)
            clientKey: apiKey, // Base64 encoded 'none' as fallback
            refreshInterval: 15 * 60, // 15min How often (in seconds) the client should poll the proxy for updates
            appName, // The name of your application. It's only used for identifying your application
            bootstrap: window?.features,
            disableRefresh: window?.features ? true : false, // prevents unleash from auto reloading.
        };
    }

    return config;
};

export { getConfig, useFlag };
